module.exports = __webpack_public_path__ + "img/2.eebcae8b.jpg";